import {http} from '@/axios'

export default function ({messenger}) {
  return http.post(`/api/bot/start-primary`, {
    messenger
  })
}
